var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgVolumeMute = function SvgVolumeMute(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 15H8a.97.97 0 0 1-.713-.287A.97.97 0 0 1 7 14v-4q0-.424.287-.713A.97.97 0 0 1 8 9h3l3.3-3.3q.476-.476 1.087-.213.613.263.613.938v11.15q0 .674-.613.938-.612.262-1.087-.213z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVolumeMute);
export { ForwardRef as ReactComponent };